// Utility to update store settings in Firestore
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

// Update the store settings with the correct address
const updateStoreSettings = async () => {
  try {
    const settingsRef = doc(db, 'settings', 'storeSettings');
    
    // Update with your correct address information
    await updateDoc(settingsRef, {
      defaultFromAddress: {
        name: 'Master Collectors Forge',
        street1: '632 Fredrico Blvd',
        city: 'Belen',
        state: 'NM',
        zip: '87002',
        country: 'US',
        phone: '505-363-6058',
        email: 'info@mastercollectorsforge.com'
      },
      // Also update the individual store fields
      storeName: 'Master Collectors Forge',
      storeAddress: '632 Fredrico Blvd, Belen, NM 87002',
      storePhone: '505-363-6058',
      storeEmail: 'info@mastercollectorsforge.com',
      updatedAt: new Date().toISOString()
    });
    
    console.log('Store settings updated successfully!');
    return true;
  } catch (error) {
    console.error('Error updating store settings:', error);
    return false;
  }
};

export default updateStoreSettings;
